import React, {useState} from "react";
import countries from "../assets/countries.json";
import "./PhoneInput.css";

export const PhoneInput = ({phone, setPhone}) => {
    const [countryCode, setCountryCode] = useState("+33");
    const [isValid, setIsValid] = useState(true);
    const PHONE_REGEX =  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

    const validatePhone = (phone) => {
        const newPhone = countryCode + phone.target.value.replace(/\s/g, "")

        console.log(newPhone);

        if (PHONE_REGEX.test(newPhone) || newPhone === "")
            setIsValid(true);
        else
            setIsValid(false);

        setPhone(phone.target.value);
    }

    return (
        <>
            <h1 className={"extra_text"}>Je vais t'offrir 10 minutes de consultation gratuite par téléphone<sup className={"index"}>(1)</sup> pour que nous puissions en parler de vive voix.</h1>
            <div className={"phone-container"}>
                <select className={"phone-select"} value={countryCode} onChange={(e) => setCountryCode(e.target.value)}>
                    {countries.map((country) => (
                        <option key={country.code} value={country.dial_code}>
                            {country.name} ({country.dial_code})
                        </option>
                    ))}
                </select>
                <input className={`phone-input ${isValid ? "" : "invalid"}`} type="tel" value={phone} onChange={validatePhone}/>
            </div>
            {!isValid && <p className="error-text">Numéro invalide</p>}
        </>
    )
}